import api from 'common/api';

export const getEdiLogListAPI = (params: any) => api.get('/edi-log-search/infolist', params);

export const getEdiLogDetailAPI = (params: any) => api.get('/edi-log-detail', params);

export const getEdiIdList = () => api.get('/edi-log-search/edi-id');
